<template>
  <div class="manager-check-page">
    <!-- ================= 工单头 ================= -->
    <div class="card">
      <div class="wo-top">
        <div>
          <div class="wo-title">{{ mozuName }}-运维经理验收</div>
          <div class="wo-desc">
            本工单用于运维经理对数据中心（{{
              mozuName
            }}）建设项目「基础设施交付」部分的验收结果确认。
          </div>
        </div>
      </div>
      <div class="rings-row">
        <div class="ring-block">
          <div class="progress-ring">
            <div class="ring" :style="ringStyle">
              <i id="ringTxt">{{ pct }}%</i>
            </div>
            <div class="ring-sub">已判定 {{ doneItems }}/{{ allItems }} 项</div>
          </div>
        </div>
        <div class="ring-block">
          <div class="big-ring" :style="bigRingStyle">
            <i id="stTotal">{{ totalFail }}</i>
          </div>
          <div class="ring-sub">未关闭问题</div>
          <div class="legend">
            <span
              ><i class="dot" style="background: var(--red)"></i>高
              <b id="stHigh">{{ totalH }}</b></span
            >
            <span
              ><i class="dot" style="background: var(--orange)"></i>中
              <b id="stMid">{{ totalM }}</b></span
            >
            <span
              ><i class="dot" style="background: var(--green)"></i>低
              <b id="stLow">{{ totalL }}</b></span
            >
          </div>
        </div>
      </div>
    </div>

    <div class="layout">
      <!-- ================= 左侧栏（PC，窄屏自动隐藏） ================= -->
      <div class="side">
        <div class="card" style="margin-bottom: 0">
          <h4 style="margin-top: 0">按专业跳转</h4>
          <div class="tree">
            <div v-for="(cat, ci) in cats" :key="ci" @click="goCat(ci)">
              {{ cat.icon }} {{ cat.name }}（{{ catItemCount(cat) }}项）
            </div>
          </div>
          <h4>复查进度</h4>
          <div style="font-size: 12px">已判定 {{ doneItems }} / {{ allItems }} 项</div>
          <div class="statbar"><i :style="{ width: pct + '%' }"></i></div>
          <div style="font-size: 12px; color: var(--red)">
            不通过项 {{ failCount }}（含否决 {{ vetoFail }}）
          </div>
          <h4>
            快捷筛选
            <span
              v-if="filter"
              style="color: var(--blue); cursor: pointer; font-weight: 400"
              @click="setFilter('')"
              >（清除）</span
            >
          </h4>
          <div class="tree">
            <div :class="{ on: filter === 'fail' }" @click="setFilter('fail')">
              ❗ 只看不通过项（<span>{{ failCount }}</span
              >）
            </div>
            <div :class="{ on: filter === 'todo' }" @click="setFilter('todo')">
              ⏳ 只看未判定项（<span>{{ todoCount }}</span
              >）
            </div>
          </div>
        </div>
      </div>

      <!-- ================= 主区 ================= -->
      <div>
        <div class="card" style="padding: 16px 16px 4px">
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
              flex-wrap: wrap;
              gap: 8px;
            "
          >
            <div style="font-weight: 700; font-size: 15px">🔍 关键项复查</div>
            <div class="dev-batch">
              <button
                class="bp"
                :disabled="isReadOnly"
                @click="!isReadOnly && batchAll('pass')"
              >
                ✓ 全部通过
              </button>
              <button
                class="bf"
                :disabled="isReadOnly"
                @click="!isReadOnly && batchAll('fail')"
              >
                ✗ 全部不通过
              </button>
            </div>
          </div>
          <div style="font-size: 12px; color: var(--ink2); margin: 4px 0 8px">
            批量操作全部检查项后可按设备逐项微调；提交前所有结果可随时修改；不通过项须填遗留问题处理意见并拍照留证
          </div>
          <div id="devList">
            <template v-for="(cat, ci) in cats">
              <div
                v-if="filter ? catVisible(cat) : true"
                :key="'cat' + ci"
                :id="'cat' + ci"
                class="cat-title"
                :ref="'cat' + ci"
              >
                {{ cat.icon }} {{ cat.name
                }}<span class="cnt">{{ catItemCount(cat) }}项关键检查项</span>
              </div>
              <div
                v-for="(d, di) in cat.devs"
                v-if="filter ? devVisible(cat, di) : true"
                :key="ci + '-' + di"
                class="dev"
                :class="{ done: devDone(cat, di) }"
              >
                <div class="dev-head">
                  <span class="dev-name">{{ d.dev }}</span>
                  <span class="dev-loc">{{ d.loc }}</span>
                  <span class="dev-prog"
                    >已判定 {{ devDoneCount(cat, di) }}/{{ d.items.length }}</span
                  >
                </div>
                <div class="rc-table-head">
                  <span>关键检查内容</span>
                  <span>检查标准</span>
                  <span>是否判定</span>
                </div>
                <div class="rc-list">
                  <div
                    v-for="(it, ii) in d.items"
                    v-if="filter ? matchFilter(cat, di, ii) : true"
                    :key="ii"
                    class="row-card"
                  >
                    <div class="rc-main">
                      <div class="rc-item">
                        <b>{{ it.n }}</b>
                      </div>
                      <div class="rc-std">{{ it.s }}</div>
                      <div class="rc-res">
                        <div class="seg">
                          <button
                            class="pass-btn"
                            :disabled="isReadOnly"
                            :class="{ 'on-pass': (ticketStatus === 'END' ? it.result : state[key(cat, di, ii)]) === 'pass' }"
                            @click="!isReadOnly && setRes(cat, di, ii, 'pass')"
                          >
                            ✓ 通过
                          </button>
                          <button
                            class="fail-btn"
                            :disabled="isReadOnly"
                            :class="{ 'on-fail': (ticketStatus === 'END' ? it.result : state[key(cat, di, ii)]) === 'fail' }"
                            @click="!isReadOnly && setRes(cat, di, ii, 'fail')"
                          >
                            ✗ 不通过
                          </button>
                        </div>
                      </div>
                    </div>
                    <div
                      class="fail-row"
                      :class="{ show: (ticketStatus === 'END' ? it.result : state[key(cat, di, ii)]) === 'fail' }"
                    >
                      <div class="fail-line">
                        <el-upload
                          action="/relay/cosfile/index"
                          list-type="picture-card"
                          accept="image/*"
                          multiple
                          :headers="headers"
                          :file-list="checkUploadFiles[key(cat, di, ii)] || []"
                          :disabled="isReadOnly"
                          :class="{ 'check-upload-readonly': isReadOnly }"
                          :on-success="
                            (response, file, fileList) =>
                              handleCheckPhotoUploadSuccess(
                                response,
                                file,
                                fileList,
                                key(cat, di, ii)
                              )
                          "
                          :on-error="handleCheckPhotoUploadError"
                          :on-remove="
                            (file, fileList) =>
                              handleCheckPhotoRemove(file, fileList, key(cat, di, ii))
                          "
                          :on-preview="handleCheckPhotoPreview"
                        >
                          <i class="ri-camera-line"></i>
                        </el-upload>
                      </div>
                      <div class="note-field show">
                        <input
                          placeholder="遗留问题处理意见"
                          v-model="notesTxt[key(cat, di, ii)]"
                          :readonly="isReadOnly"
                          :disabled="isReadOnly"
                          @blur="handleNoteBlur(cat, di, ii)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <div v-if="filter && noMatch" class="card">
              <div style="text-align: center; color: var(--ink2); padding: 20px">
                当前筛选条件下没有匹配的检查项
              </div>
            </div>
          </div>
        </div>

        <!-- ================= 补充问题（标准清单外） ================= -->
        <div class="card">
          <div style="font-weight: 700; font-size: 15px; margin-bottom: 4px">
            ➕ 补充问题（标准清单外）
          </div>
          <div
            style="
              margin-bottom: 10px;
              padding: 10px 12px;
              border: 1px dashed var(--red);
              border-radius: 8px;
              background: var(--red-bg);
              font-size: 13px;
              color: var(--red);
              font-weight: 600;
              line-height: 1.6;
            "
          >
            ⚠️ 如有其它无法在验收前销项的高风险问题，请在此添加
          </div>
          <div id="supList" style="margin-bottom: 12px">
            <div
              v-if="!supItems.length"
              style="
                text-align: center;
                color: var(--ink2);
                font-size: 13px;
                padding: 14px;
              "
            >
              暂无补充问题
            </div>
            <div v-for="(a, ai) in supItems" :key="ai" class="row-card sup">
              <div class="rc-main">
                <div class="rc-item">
                  <b>{{ a.device_type }}</b>
                  <span class="rlv" :class="a.problem_level">{{
                    lvText(a.problem_level)
                  }}</span>
                </div>
                <div class="rc-std">{{ a.issue_description }}</div>
                <div class="rc-res">
                  <span
                    style="
                      display: inline-block;
                      padding: 6px 14px;
                      border-radius: 8px;
                      background: var(--red);
                      color: #fff;
                      font-weight: 600;
                      font-size: 13px;
                    "
                    >✗ 不通过</span
                  >
                  <button v-if="!isReadOnly" class="del-btn" @click="delSup(ai)">
                    🗑 删除
                  </button>
                </div>
              </div>
              <div class="fail-row show">
                <div class="fail-line">
                  <div class="thumbs">
                    <img
                      v-for="(s, x) in eviFiles['sup_' + ai] || []"
                      :key="x"
                      :src="s"
                      @click="viewPhoto('sup_' + ai, x)"
                      title="点击放大"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button v-if="!isReadOnly" class="sup-entry-btn" @click="openSupModal">
            ＋ 添加补充问题
          </button>
        </div>

        <!-- ================= 结论区 ================= -->
        <div class="card">
          <div style="font-weight: 700; margin-bottom: 10px">📝 验收结果</div>
          <div class="concl-grid">
            <div>
              <div class="radio-row">
                <label :class="{ 'sel-pass': displayConcl === 'pass' }">
                  <input
                    type="radio"
                    name="c"
                    :checked="displayConcl === 'pass'"
                    disabled
                  />
                  <div>
                    <b>通过</b><br /><span style="font-size: 12px; color: var(--ink2)"
                      >全部关键项复查合格</span
                    >
                  </div>
                </label>
                <label :class="{ 'sel-warn': displayConcl === 'warn' }">
                  <input
                    type="radio"
                    name="c"
                    :checked="displayConcl === 'warn'"
                    disabled
                  />
                  <div>
                    <b>有缺陷通过</b><br /><span
                      style="font-size: 12px; color: var(--ink2)"
                      >存在不通过项（检查项或补充问题）时自动选择，附遗留问题处理意见</span
                    >
                  </div>
                </label>
              </div>
              <div
                v-show="displayConcl === 'warn'"
                style="
                  margin-top: 10px;
                  padding: 12px 14px;
                  border: 1px solid var(--red);
                  border-radius: 8px;
                  background: var(--red-bg);
                "
              >
                <div
                  style="
                    font-size: 13px;
                    color: var(--red);
                    font-weight: 600;
                    line-height: 1.6;
                    margin-bottom: 8px;
                  "
                >
                  ⚠️
                  当前存在影响数据中心安全运营的高风险问题，请先完成问题销项再验收，如数据中心经理同意先行验收，请记录原因和临时解决方案
                </div>
                <textarea
                  v-model="riskReason"
                  :readonly="isReadOnly"
                  :disabled="isReadOnly"
                  @blur="handleRiskReasonBlur"
                  rows="3"
                  placeholder="请填写数据中心经理同意先行验收的原因…"
                  style="
                    width: 100%;
                    border: 1px solid var(--line);
                    border-radius: 6px;
                    padding: 8px 10px;
                    font-size: 13px;
                    resize: vertical;
                    box-sizing: border-box;
                  "
                ></textarea>
                <div class="fail-line" style="margin-top: 8px">
                  <el-upload
                    action="/relay/cosfile/index"
                    multiple
                    :headers="headers"
                    :file-list="riskFiles"
                    :disabled="isReadOnly"
                    :class="{ 'risk-upload-readonly': isReadOnly }"
                    :on-success="handleRiskUploadSuccess"
                    :on-error="handleRiskUploadError"
                    :on-remove="handleRiskUploadRemove"
                    :on-preview="handleRiskUploadPreview"
                  >
                    <button
                      v-if="!isReadOnly"
                      type="button"
                      class="cam-btn"
                      style="margin-left: 0"
                    >
                      📎 上传附件
                    </button>
                  </el-upload>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 照片上传（隐藏）与放大查看弹层 -->
    <input
      type="file"
      id="fp"
      accept="image/*"
      multiple
      style="display: none"
      @change="onPick"
    />
    <div class="img-modal" :class="{ show: imgModal }" @click.self="closePhoto">
      <img id="bigImg" :src="bigImgSrc" alt="证据照片" />
      <div class="bar">
        <button
          v-if="!isReadOnly && curPhoto && !String(curPhoto.id).startsWith('sup_')"
          class="del"
          @click="delPhoto"
        >
          🗑 删除此照片
        </button>
        <button class="cls" @click="closePhoto">关闭</button>
      </div>
    </div>

    <!-- 补充问题弹窗 -->
    <div class="sup-modal" :class="{ show: supModal }" @click.self="closeSupModal">
      <div class="sup-dialog" @click.stop>
        <div class="sup-dialog-title">补充问题（标准清单外）</div>
        <div class="sup-form">
          <div class="row">
            <div class="combo" style="flex: 1; min-width: 180px">
              <input
                type="text"
                v-model="supTypeSearch"
                class="combo-input"
                placeholder="🔍 输入关键字搜索设备类型（如 UPS、配电、空调）"
                autocomplete="off"
                @focus="renderSupTypeList"
                @input="onSupTypeInput"
                @keydown="onSupTypeKey"
              />
              <div class="combo-list" v-show="supListShow">
                <div
                  v-for="(t, i) in supCur"
                  :key="i"
                  class="opt"
                  :class="{ hl: i === supHi }"
                  @click="pickSupType(t)"
                >
                  {{ t }}
                </div>
                <div v-if="!supCur.length" class="combo-empty">未找到匹配的设备类型</div>
              </div>
            </div>
            <span
              style="
                font-size: 13px;
                color: var(--ink2);
                white-space: nowrap;
                display: inline-flex;
                align-items: center;
                gap: 6px;
              "
              >问题等级：<span class="rlv h">高风险</span></span
            >
          </div>
          <div class="row">
            <input type="text" v-model="supStd" placeholder="* 问题描述 / 判定依据" />
          </div>
          <div class="row">
            <input type="text" v-model="supOpinion" placeholder="遗留问题处理意见" />
          </div>
          <div class="row">
            <el-upload
              action="/relay/cosfile/index"
              list-type="picture-card"
              accept="image/*"
              multiple
              :headers="headers"
              :file-list="supUploadFiles"
              :class="{ 'sup-upload-invalid': supUploadInvalid }"
              :on-success="handleSupPhotoUploadSuccess"
              :on-error="handleSupPhotoUploadError"
              :on-remove="handleSupPhotoRemove"
              :on-preview="handleSupPhotoPreview"
            >
              <i class="ri-camera-line"></i>
            </el-upload>
          </div>
          <div class="row" style="justify-content: flex-end">
            <button class="cancel-btn" @click="closeSupModal">取消</button>
            <button class="ok-btn" @click="addSup">＋ 添加</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getDataByNbrokerUrl,
  getVariables,
  getTicketData,
} from "@/api/workBench/ticketApi.js";

/* ============================================================
   验收关键设备复查工单 - serviceCheck
   说明：原 test 目录下的原生 HTML/CSS/JS 已转换为本 Vue 组件。
   ============================================================ */

/* ---------- 数据库问题（标题栏统计用） ---------- */
const CHECK_RESULT_CACHE = new Map();

const PROFESSIONALS = [
  { name: "暖通", icon: "❄️" },
  { name: "配电", icon: "⚡" },
  { name: "消防", icon: "🔥" },
  { name: "弱电", icon: "🔌" },
];

/* ---------- 过滤高风险项，剔除无高风险项设备/分组 ---------- */
export default {
  name: "ServiceCheck",
  props: {
    mozuName: {
      type: String,
      default: false,
    },
    ticketId: {
      type: String,
      default: "",
    },
    context: {
      type: Object,
      default: () => {},
    },
    deviceList: {
      type: Array,
      default: () => [],
    },
    checkList: {
      type: Array,
      default: () => [],
    },
    problemData: {
      type: Array,
      default: () => [],
    },
    uploadPass: {
      type: Array,
      default: () => [],
    },
    remarkInput: {
      type: String,
      default: "",
    },
    acceptanceResult: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      /* 判定状态：key='d{cat}_{dev}_{item}' -> 'pass'|'fail' */
      state: {},
      notesTxt: {},
      /* 人工补充的清单外问题 */
      supItems: [],
      filter: "",
      /* 照片证据：key -> [dataURL...] */
      eviFiles: {},
      checkUploadFiles: {},
      pickTarget: null,
      curPhoto: null,
      bigImgSrc: "",
      imgModal: false,
      /* 补充问题弹窗 */
      supModal: false,
      supType: "",
      supTypeSearch: "",
      supListShow: false,
      supHi: 0,
      supCur: [],
      supStd: "",
      supOpinion: "",
      supUploadFiles: [],
      supUploadInvalid: false,
      headers: {
        authToken: sessionStorage.getItem("AuthToken"),
      },
      /* 先行验收原因附件 */
      riskFiles: [],
      riskReason: "",
      ticketStatus: "OPEN",
      openProblemCount: 0,
      openProblemLevels: { high: 0, mid: 0, low: 0 },
      defaultCheckResultInitialized: null,
      variablesLoaded: false,
      paramsData: {
        context: {},
        args: {
          process_data: {},
          process_user: this.$store.state.user.name,
        },
      },
      problemServiceUrl: "http://ibroker-jiewei:8080/nBroker/api/v1/task",
      searchParams: {
        context: {
          service_name: "Db",
          method_name: "query",
          instanceId: "",
          taskId: "",
          parent_id: "",
          parent_task_id: "",
          svckey: "flowable",
        },
        args: {
          db: "jiewei",
          table_name: "on_site_check_problem_ticket",
          start: 0,
          size: 1000,
          fields: ["problem_level", "mozu_name", "major", "device_type"],
          conditions: {
            ticket_status: ["处理中", "审核中"],
            mozu_name: "",
          },
        },
      },
      user: sessionStorage.getItem("userid"),
      searchServiceUrl: "http://ibroker-api:8080/nBroker/api/v1/task",
    };
  },
  mounted() {},
  computed: {
    cats() {
      return PROFESSIONALS.map((professional) => {
        const professionalItems = (this.checkList || [])
          .filter((item) => item.professional === professional.name)
          .slice();
        const groupedDevices = professionalItems.reduce((groups, item) => {
          const deviceType = item.check_item_type || "未命名检查项";
          if (!groups[deviceType]) groups[deviceType] = [];
          groups[deviceType].push(item);
          return groups;
        }, {});

        return {
          name: professional.name,
          icon: professional.icon,
          devs: Object.keys(groupedDevices).map((deviceType) => ({
            dev: deviceType,
            loc: "",
            items: groupedDevices[deviceType]
              .sort((a, b) => (a.check_order || 0) - (b.check_order || 0))
              .map((item) => ({
                id: item.id,
                result:
                  this.ticketStatus === "END" ? item.check_result || "" : "",
                n: item.check_content || "未命名检查内容",
                s: item.check_standard || "",
                lv: item.level === "高风险" ? "h" : item.level === "中风险" ? "m" : "l",
                veto: false,
              })),
          })),
        };
      }).filter((cat) => cat.devs.some((dev) => dev.items.length > 0));
    },
    supTypes() {
      const list = Array.isArray(this.deviceList) ? this.deviceList : [];
      return [
        ...new Set(
          list
            .map((device) => {
              if (typeof device === "string") return device;
              if (!device || typeof device !== "object") return "";
              return (
                device.device_type ||
                device.deviceType ||
                device.device_name ||
                device.deviceName ||
                device.name ||
                device.type ||
                ""
              );
            })
            .map((value) => String(value).trim())
            .filter(Boolean)
        ),
      ];
    },
    /* 统计环 */
    pct() {
      return this.allItems ? Math.round((this.doneItems / this.allItems) * 100) : 0;
    },
    allItems() {
      return (this.checkList || []).length + this.supItems.length;
    },
    doneItems() {
      let n = 0;
      this.cats.forEach((cat) =>
        cat.devs.forEach((d) =>
          d.items.forEach((it, i) => {
            if (
              (this.ticketStatus === "END" ? it.result : this.state[this.keyOf(cat, d, i)])
            ) n++;
          })
        )
      );
      n += this.supItems.length;
      return n;
    },
    failCount() {
      let n = 0;
      this.cats.forEach((cat) =>
        cat.devs.forEach((d) =>
          d.items.forEach((it, i) => {
            if (this.state[this.keyOf(cat, d, i)] === "fail") n++;
          })
        )
      );
      n += this.supItems.length;
      return n;
    },
    vetoFail() {
      let n = 0;
      this.cats.forEach((cat) =>
        cat.devs.forEach((d) =>
          d.items.forEach((it, i) => {
            if (this.state[this.keyOf(cat, d, i)] === "fail" && it.veto) n++;
          })
        )
      );
      return n;
    },
    missingFix() {
      let n = 0;
      this.cats.forEach((cat) =>
        cat.devs.forEach((d) =>
          d.items.forEach((it, i) => {
            const k = this.keyOf(cat, d, i);
            if (this.state[k] === "fail" && !(this.notesTxt[k] || "").trim()) n++;
          })
        )
      );
      this.supItems.forEach((a) => {
        if (!(a.cause_solution_process || "").trim()) n++;
      });
      return n;
    },
    todoCount() {
      return this.allItems - this.doneItems;
    },
    /* 未关闭问题统计（复查 + 数据库问题） */
    openH() {
      let n = 0;
      this.cats.forEach((cat) =>
        cat.devs.forEach((d) =>
          d.items.forEach((it, i) => {
            if (this.state[this.keyOf(cat, d, i)] === "fail" && it.lv === "h") n++;
          })
        )
      );
      this.supItems.forEach((a) => {
        if (!["m", "中风险", "l", "低风险"].includes(a.problem_level)) n++;
      });
      n += this.openProblemLevels.high + this.openProblemUnclassified;
      return n;
    },
    openM() {
      let n = 0;
      this.cats.forEach((cat) =>
        cat.devs.forEach((d) =>
          d.items.forEach((it, i) => {
            if (this.state[this.keyOf(cat, d, i)] === "fail" && it.lv === "m") n++;
          })
        )
      );
      this.supItems.forEach((a) => {
        if (["m", "中风险"].includes(a.problem_level)) n++;
      });
      n += this.openProblemLevels.mid;
      return n;
    },
    openL() {
      let n = 0;
      this.cats.forEach((cat) =>
        cat.devs.forEach((d) =>
          d.items.forEach((it, i) => {
            if (this.state[this.keyOf(cat, d, i)] === "fail" && it.lv === "l") n++;
          })
        )
      );
      this.supItems.forEach((a) => {
        if (["l", "低风险"].includes(a.problem_level)) n++;
      });
      n += this.openProblemLevels.low;
      return n;
    },
    openProblemUnclassified() {
      const classified =
        this.openProblemLevels.high +
        this.openProblemLevels.mid +
        this.openProblemLevels.low;
      return Math.max(this.openProblemCount - classified, 0);
    },
    totalFail() {
      return this.totalH + this.totalM + this.totalL;
    },
    totalH() {
      return this.openH;
    },
    totalM() {
      return this.openM;
    },
    totalL() {
      return this.openL;
    },
    /* 大环（未关闭问题）样式 */
    bigRingStyle() {
      const tot = this.totalFail;
      if (!tot) return { background: "conic-gradient(var(--gray-bg) 0 100%)" };
      const pH = (this.totalH / tot) * 100;
      const pM = (this.totalM / tot) * 100;
      return {
        background: `conic-gradient(var(--red) 0 ${pH}%, var(--orange) ${pH}% ${
          pH + pM
        }%, var(--green) ${pH + pM}% 100%)`,
      };
    },
    /* 进度环样式 */
    ringStyle() {
      const pct = this.pct;
      return {
        background: `conic-gradient(var(--blue) 0 ${pct}%, #e9edf3 ${pct}% 100%)`,
      };
    },
    /* 结论：'pass' | 'warn' | null */
    concl() {
      if (this.doneItems !== this.allItems) return null;
      const dbOpenH = this.openProblemLevels.high;
      const conclFail = this.failCount + dbOpenH;
      return conclFail ? "warn" : "pass";
    },
    displayConcl() {
      if (this.ticketStatus !== "END" || !this.acceptanceResult) return this.concl;
      return ["通过", "pass"].includes(this.acceptanceResult)
        ? "pass"
        : ["有缺陷通过", "warn"].includes(this.acceptanceResult)
        ? "warn"
        : this.concl;
    },
    noMatch() {
      if (!this.filter) return false;
      let any = false;
      this.cats.forEach((cat) =>
        cat.devs.forEach((d) =>
          d.items.forEach((it, i) => {
            if (this.matchFilter(cat, d, i)) any = true;
          })
        )
      );
      return !any;
    },
    isReadOnly() {
      return this.ticketStatus !== "OPEN";
    },
  },
  watch: {
    mozuName(newVal) {
      console.log(newVal, "mozu name =====");
      if (newVal) this.loadOpenProblems();
    },
    ticketId(newVal) {
      console.log(newVal, "ticket id=====");
      this.loadOpenProblems();
    },
    ticketStatus(newVal) {
      if (newVal === "END") {
        this.$nextTick(() => {
          this.syncCheckListResult(this.checkList);
          this.syncAcceptanceResult();
        });
      }
    },
    context: {
      async handler(obj) {
        console.log(obj, "context =====");
        console.log(obj?.ticketId, "ticketId ======");
        if (!obj?.ticketId) {
          if (!this.variablesLoaded) this.loadVariables();
          return;
        }
        try {
          const result = await getTicketData(obj.ticketId);
          console.log(result, "ticketData ======");
          const list = result?.data?.List || [];
          const ticket = list[0];
          this.ticketStatus = ticket?.TicketStatus || "OPEN";
          if (this.ticketStatus === "END") {
            this.initSupItems(this.cloneProblemData(this.problemData));
            this.syncCheckListResult(this.checkList);
            this.syncAcceptanceResult();
          } else {
            this.loadVariables();
          }
        } catch (error) {
          console.error(error, "get ticket data failed ======");
          if (!this.variablesLoaded) this.loadVariables();
        }
      },
      immediate: true,
    },
    checkList: {
      handler(list) {
        console.log(list, "checkList =====");
        this.updateDefaultCheckResult(list);
        if (!Array.isArray(list)) return;
        Object.keys(this.state).forEach((key) => {
          const itemId = key.split("_").pop();
          if (!list.some((item) => String(item.id) === itemId))
            this.$delete(this.state, key);
        });
        if (this.ticketStatus === "END") this.syncCheckListResult(list);
      },
      immediate: true,
    },
    deviceList: {
      handler(list) {
        console.log(list, "deviceList ====");
      },
      immediate: true,
    },
    problemData: {
      handler(list) {
        console.log(list, "problemData ====");
        if (this.ticketStatus === "END") {
          this.initSupItems(this.cloneProblemData(list));
        }
      },
      immediate: true,
      deep: true,
    },
    acceptanceResult: {
      handler() {
        console.log(this.acceptanceResult, "acceptanceResult =====");
        if (this.ticketStatus === "END") this.syncAcceptanceResult();
      },
      immediate: true,
    },
    uploadPass: {
      handler() {
        console.log(this.uploadPass, "uploadPass =====");
        if (this.ticketStatus === "END") this.syncAcceptanceResult();
      },
      immediate: true,
      deep: true,
    },
    remarkInput: {
      handler() {
        console.log(this.remarkInput, "remarkInput =====");
        if (this.ticketStatus === "END") this.syncAcceptanceResult();
      },
      immediate: true,
    },
  },
  methods: {
    syncCheckListResult(list) {
      if (this.ticketStatus !== "END" || !Array.isArray(list)) return;
      const cats = this.cats;
      list.forEach((item) => {
        let currentCat;
        let currentDevice;
        let current;
        cats.some((cat) =>
          cat.devs.some((device) =>
            device.items.some((checkItem) => {
              if (String(checkItem.id) !== String(item.id)) return false;
              currentCat = cat;
              currentDevice = device;
              current = checkItem;
              return true;
            })
          )
        );
        if (!current || !currentCat || !currentDevice) return;
        const cat = currentCat;
        const device = currentDevice;
        const catIndex = cats.indexOf(cat);
        const deviceIndex = cat.devs.indexOf(device);
        const itemIndex = device.items.indexOf(current);
        if (catIndex < 0 || deviceIndex < 0 || itemIndex < 0) return;
        const key = `d${catIndex}_${deviceIndex}_${current.id || itemIndex}`;
        if (item.check_result !== undefined && item.check_result !== null) {
          this.$set(this.state, key, item.check_result);
        }
        if (item.check_opinion !== undefined) {
          this.$set(this.notesTxt, key, item.check_opinion || "");
        }
        if (Array.isArray(item.check_photo)) {
          this.$set(this.checkUploadFiles, key, [...item.check_photo]);
        }
      });
    },
    syncAcceptanceResult() {
      if (this.ticketStatus !== "END") return;
      if (this.remarkInput !== undefined && this.remarkInput !== null) {
        this.riskReason = this.remarkInput;
      }
      if (Array.isArray(this.uploadPass)) {
        this.riskFiles = this.uploadPass.map((item) => ({
          name: item?.name || item?.fileName || "附件",
          url: item?.url || item?.URL || item?.response?.FileList?.[0]?.url || "",
          size: item?.size || 0,
        }));
      }
    },
    async loadVariables() {
      if (this.variablesLoaded) return;
      this.variablesLoaded = true;

      const instanceId = this.context?.instanceId;
      if (!instanceId) {
        this.initSupItems([]);
        return;
      }

      try {
        const result = await getVariables(
          ["problem_data", "check_result", "acceptance_result", "remark", "upload"],
          instanceId
        );
        console.log(result, "result ===========");
        const problemData = Array.isArray(result?.problem_data)
          ? result.problem_data
          : [];
        this.initSupItems(this.cloneProblemData(problemData));
        if (result?.remark) {
          this.riskReason = result.remark;
        }
        if (Array.isArray(result?.upload)) {
          this.riskFiles = result.upload.map((item) => ({
            name: item.name || item.fileName || "附件",
            url: item.url || item.URL || "",
            size: item.size || 0,
          }));
        }
      } catch (error) {
        this.initSupItems([]);
        console.error(error, "variables query failed");
      }
    },
    cloneProblemData(list) {
      return list.map((problem) => ({
        ...(problem || {}),
        problem_photo: Array.isArray(problem?.problem_photo)
          ? problem.problem_photo.map((photo) => ({ ...(photo || {}) }))
          : problem?.problem_photo,
      }));
    },
    normalizeProblemPhotos(value) {
      if (!value || value === "None") return [];
      let photos = value;
      if (typeof photos === "string") {
        try {
          photos = JSON.parse(photos);
        } catch (error) {
          photos = [];
        }
      }
      if (!Array.isArray(photos)) photos = [photos];
      return photos
        .map((photo, index) => {
          const file = photo?.response?.FileList?.[0] || photo;
          const url = file?.url || file?.URL || (typeof file === "string" ? file : "");
          return url ? { name: file?.name || `问题照片${index + 1}`, url } : null;
        })
        .filter(Boolean);
    },
    serializeProblemPhotos(value) {
      return JSON.stringify(this.normalizeProblemPhotos(value));
    },
    initSupItems(list) {
      if (!Array.isArray(list)) {
        this.supItems = [];
        return;
      }
      this.supItems = list.map((problem, index) => {
        const photos = this.normalizeProblemPhotos(problem.problem_photo);
        this.$set(
          this.eviFiles,
          `sup_${index}`,
          photos.map((photo) => photo.url).filter(Boolean)
        );
        return {
          ticket_id: problem.ticket_id || "",
          device_type: problem.device_type || "",
          problem_type: problem.problem_type || "补充问题",
          issue_description: problem.issue_description || "",
          cause_solution_process: problem.cause_solution_process || "",
          problem_photo: JSON.stringify(photos),
          problem_level: problem.problem_level || "h",
        };
      });
    },
    async updateCheckResult(checkResult) {
      if (this.isReadOnly) return;
      const cacheKey =
        this.ticketId || this.context?.ticketId || this.context?.taskId || "default";

      const processData = {
        check_result: checkResult,
      };

      // if (checkResult === true) {
      //   processData.jw_check_list = this.getCheckListWithResult();
      // }

      if (this.concl === "pass") {
        processData.acceptance_result = "通过";
      } else if (this.concl === "warn") {
        processData.acceptance_result = "有缺陷通过";
        processData.remark = this.riskReason || "";
        processData.upload = (this.riskFiles || [])
          .map((file) => ({
            name: file.name || file.fileName || "附件",
            url: file?.response?.FileList?.[0]?.url || file?.url || file?.URL || "",
            size: file.size || 0,
          }))
          .filter((item) => item.url);
      }

      const cacheValue = JSON.stringify(processData);
      if (CHECK_RESULT_CACHE.get(cacheKey) === cacheValue) return;
      CHECK_RESULT_CACHE.set(cacheKey, cacheValue);

      this.paramsData.args.process_data = processData;
      this.paramsData.args.process_user = this.user;
      this.paramsData.context = {
        ...this.context,
        method_name: "update",
      };
      try {
        await getDataByNbrokerUrl(this.paramsData, this.problemServiceUrl);
      } catch (error) {
        CHECK_RESULT_CACHE.delete(cacheKey);
        throw error;
      }
    },
    updateDefaultCheckResult(list) {
      if (this.isReadOnly) return;
      if (!Array.isArray(list) || this.defaultCheckResultInitialized !== null) return;
      this.defaultCheckResultInitialized = list.length;
      this.updateCheckResult(list.length === 0).catch(() => {});
    },
    allCheckItemsDone() {
      return this.doneItems === this.allItems;
    },
    validateAndUpdateCheckResult(showWarning = false) {
      if (this.isReadOnly) return false;
      const allItemsDone = this.allCheckItemsDone();
      const missingOpinion = this.missingFix > 0;
      const missingRiskReason = this.concl === "warn" && !this.riskReason.trim();
      const checkResult = allItemsDone && !missingOpinion && !missingRiskReason;

      if (showWarning) {
        if (!allItemsDone) {
          this.$message.warning("请完成全部检查项后再提交验收结果");
        } else if (missingOpinion) {
          this.$message.warning("请填写不通过检查项的遗留问题处理意见");
        } else if (missingRiskReason) {
          this.$message.warning("请填写临时解决方案");
        }
      }

      this.updateCheckResult(checkResult).catch(() => {});
      return checkResult;
    },
    tryUpdateCheckResult() {
      return this.validateAndUpdateCheckResult();
    },
    handleRiskReasonBlur() {
      if (this.isReadOnly) return;
      this.validateAndUpdateCheckResult(true);
    },
    async loadOpenProblems() {
      const params = JSON.parse(JSON.stringify(this.searchParams));
      params.args.conditions.mozu_name = this.mozuName || "";
      try {
        const result = await getDataByNbrokerUrl(params, this.searchServiceUrl);
        const resultData = result?.data?.result || {};
        const rows = Array.isArray(resultData) ? resultData : resultData.data || [];
        const levels = rows.reduce(
          (counts, row) => {
            const level = row.problem_level;
            if (level === "高风险" || level === "h") counts.high++;
            else if (level === "中风险" || level === "m") counts.mid++;
            else if (level === "低风险" || level === "l") counts.low++;
            return counts;
          },
          { high: 0, mid: 0, low: 0 }
        );
        this.openProblemCount = rows.length;
        this.openProblemLevels = levels;
      } catch (error) {
        this.openProblemCount = 0;
        this.openProblemLevels = { high: 0, mid: 0, low: 0 };
        console.error(error, "open problems query failed");
      }
    },
    keyOf(cat, d, i) {
      const item = d.items[i];
      return `d${this.cats.indexOf(cat)}_${cat.devs.indexOf(d)}_${item.id || i}`;
    },
    key(cat, di, ii) {
      const item = cat.devs[di].items[ii];
      return `d${this.cats.indexOf(cat)}_${di}_${item.id || ii}`;
    },
    matchFilter(cat, d, ii) {
      if (!this.filter) return true;
      const v = this.state[this.keyOf(cat, d, ii)];
      if (this.filter === "fail") return v === "fail";
      if (this.filter === "todo") return !v;
      return true;
    },
    catVisible(cat) {
      if (!this.filter) return true;
      return cat.devs.some((d, di) => this.devVisible(cat, di));
    },
    devVisible(cat, di) {
      if (!this.filter) return true;
      const d = cat.devs[di];
      return d.items.some((it, i) => this.matchFilter(cat, d, i));
    },
    catItemCount(cat) {
      return cat.devs.reduce((a, d) => a + d.items.length, 0);
    },
    devDoneCount(cat, di) {
      const d = cat.devs[di];
      return d.items.filter((it, i) => this.state[this.key(cat, di, i)]).length;
    },
    devDone(cat, di) {
      const d = cat.devs[di];
      return d.items.every((it, i) => this.state[this.key(cat, di, i)] === "pass");
    },
    getCheckListWithResult() {
      return (this.checkList || []).map((item) => {
        const cat = this.cats.find((currentCat) =>
          currentCat.devs.some((device) =>
            device.items.some((checkItem) => String(checkItem.id) === String(item.id))
          )
        );
        const device = cat?.devs.find((currentDevice) =>
          currentDevice.items.some(
            (checkItem) => String(checkItem.id) === String(item.id)
          )
        );
        const itemIndex = device?.items.findIndex(
          (checkItem) => String(checkItem.id) === String(item.id)
        );
        const itemKey =
          cat && device && itemIndex >= 0
            ? this.key(cat, cat.devs.indexOf(device), itemIndex)
            : "";
        this.$set(item, "check_result", itemKey ? this.state[itemKey] || "" : "");
        this.$set(
          item,
          "check_photo",
          itemKey ? [...(this.checkUploadFiles[itemKey] || [])] : []
        );
        this.$set(item, "check_opinion", itemKey ? this.notesTxt[itemKey] || "" : "");
        return item;
      });
    },
    logCheckListWithResult() {
      const checkListWithResult = this.getCheckListWithResult();
      console.log("关键项复查数组：", checkListWithResult);
      this.$emit("updateData", checkListWithResult);
    },
    setRes(cat, di, ii, v) {
      if (this.isReadOnly) return;
      this.$set(this.state, this.key(cat, di, ii), v);
      this.$nextTick(() => {
        this.logCheckListWithResult();
        this.validateAndUpdateCheckResult();
      });
    },
    batchAll(v) {
      if (this.isReadOnly) return;
      this.cats.forEach((cat) =>
        cat.devs.forEach((d) =>
          d.items.forEach((it, i) => {
            this.$set(this.state, this.keyOf(cat, d, i), v);
          })
        )
      );
      this.$nextTick(() => {
        this.logCheckListWithResult();
        this.validateAndUpdateCheckResult();
      });
    },
    handleNoteBlur(cat, di, ii) {
      if (this.isReadOnly) return;
      const k = this.key(cat, di, ii);
      this.logCheckListWithResult();
      this.validateAndUpdateCheckResult(true);
    },
    setFilter(f) {
      this.filter = this.filter === f ? "" : f;
    },
    goCat(i) {
      const el = this.$refs["cat" + i];
      if (el && el[0]) {
        el[0].scrollIntoView({ behavior: "smooth", block: "start" });
        el[0].style.transition = "background .3s";
        el[0].style.background = "var(--blue-bg)";
        setTimeout(() => {
          el[0].style.background = "";
        }, 1200);
      }
    },
    /* ===== 照片证据 ===== */
    handleCheckPhotoUploadSuccess(response, file, fileList, id) {
      file.response = response;
      file.url = response?.FileList?.[0]?.url || response?.url || file.url || "";
      this.$set(this.checkUploadFiles, id, fileList);
      this.$set(
        this.eviFiles,
        id,
        fileList.map((item) => this.photoUrl(item)).filter(Boolean)
      );
      this.logCheckListWithResult();
    },
    handleCheckPhotoUploadError() {
      this.$message.error("检查照片上传失败");
    },
    handleCheckPhotoRemove(file, fileList, id) {
      this.$set(this.checkUploadFiles, id, fileList);
      this.$set(
        this.eviFiles,
        id,
        fileList.map((item) => this.photoUrl(item)).filter(Boolean)
      );
      this.logCheckListWithResult();
    },
    handleCheckPhotoPreview(file) {
      const url = this.photoUrl(file);
      if (url) window.open(url, "_blank");
    },
    /* ===== 照片证据 ===== */
    onPick(ev) {
      if (this.isReadOnly) return;
      const files = Array.from(ev.target.files || []);
      if (!files.length || !this.pickTarget) return;
      const id = this.pickTarget;
      if (!this.eviFiles[id]) this.$set(this.eviFiles, id, []);
      files.forEach((f) => {
        const r = new FileReader();
        r.onload = (e) => {
          this.eviFiles[id].push(e.target.result);
        };
        r.readAsDataURL(f);
      });
    },
    viewPhoto(id, x) {
      this.curPhoto = { id, x };
      this.bigImgSrc = this.eviFiles[id][x];
      this.imgModal = true;
    },
    delPhoto() {
      if (this.isReadOnly || !this.curPhoto) return;
      const id = this.curPhoto.id;
      const fileList = [...(this.checkUploadFiles[id] || [])];
      fileList.splice(this.curPhoto.x, 1);
      this.$set(this.checkUploadFiles, id, fileList);
      this.$set(
        this.eviFiles,
        id,
        fileList.map((file) => this.photoUrl(file)).filter(Boolean)
      );
      this.logCheckListWithResult();
      this.closePhoto();
    },
    closePhoto() {
      this.curPhoto = null;
      this.imgModal = false;
    },
    /* ===== 先行验收原因附件 ===== */
    handleRiskUploadSuccess(response, file, fileList) {
      file.response = response;
      file.url = response?.FileList?.[0]?.url || response?.url || file.url || "";
      this.riskFiles = fileList;
      this.validateAndUpdateCheckResult();
    },
    handleRiskUploadError() {
      this.$message.error("附件上传失败");
    },
    handleRiskUploadRemove(file, fileList) {
      this.riskFiles = fileList;
      this.validateAndUpdateCheckResult();
    },
    handleRiskUploadPreview(file) {
      const url =
        file?.response?.FileList?.[0]?.url ||
        file?.url ||
        file?.URL ||
        file?.response?.url ||
        "";
      if (url) window.open(url, "_blank");
    },
    /* ===== 补充问题 ===== */
    photoUrl(photo) {
      return photo?.response?.FileList?.[0]?.url || photo?.url || "";
    },
    hasSupUploadedPhoto() {
      return this.supUploadFiles.some(
        (file) => file.status === "success" && this.photoUrl(file)
      );
    },
    handleSupPhotoUploadSuccess(response, file, fileList) {
      file.response = response;
      this.supUploadFiles = fileList;
      this.supUploadInvalid = false;
    },
    handleSupPhotoUploadError() {
      this.$message.error("照片上传失败");
    },
    handleSupPhotoRemove(file, fileList) {
      this.supUploadFiles = fileList;
      this.supUploadInvalid = fileList.length === 0;
    },
    handleSupPhotoPreview(file) {
      const url = this.photoUrl(file);
      if (url) window.open(url, "_blank");
    },
    lvText(lv) {
      return lv === "h" ? "高" : lv === "m" ? "中" : "低";
    },
    openSupModal() {
      if (this.isReadOnly) return;
      this.supType = "";
      this.supTypeSearch = "";
      this.supListShow = false;
      this.supStd = "";
      this.supOpinion = "";
      this.supUploadFiles = [];
      this.supUploadInvalid = false;
      this.supModal = true;
    },
    closeSupModal() {
      this.supModal = false;
    },
    renderSupTypeList() {
      const kw = (this.supTypeSearch || "").trim().toLowerCase();
      this.supCur = kw
        ? this.supTypes.filter((t) => t.toLowerCase().includes(kw))
        : this.supTypes;
      this.supListShow = true;
    },
    onSupTypeInput() {
      this.supType = "";
      this.supHi = 0;
      this.renderSupTypeList();
    },
    onSupTypeKey(e) {
      if (e.key === "ArrowDown") {
        this.supHi = Math.min(this.supHi + 1, this.supCur.length - 1);
        e.preventDefault();
      } else if (e.key === "ArrowUp") {
        this.supHi = Math.max(this.supHi - 1, 0);
        e.preventDefault();
      } else if (e.key === "Enter") {
        if (this.supCur[this.supHi]) this.pickSupType(this.supCur[this.supHi]);
        e.preventDefault();
      } else if (e.key === "Escape") {
        this.supListShow = false;
      }
    },
    pickSupType(v) {
      this.supType = v;
      this.supTypeSearch = v;
      this.supListShow = false;
    },
    async addSup() {
      if (this.isReadOnly) return;
      if (!this.supType) {
        this.$message.warning("请选择设备类型");
        return;
      }
      if (!this.supStd.trim()) {
        this.$message.warning("请填写问题描述 / 判定依据");
        return;
      }
      if (!this.supOpinion.trim()) {
        this.$message.warning("请填写遗留问题处理意见");
        return;
      }
      if (!this.hasSupUploadedPhoto()) {
        this.supUploadInvalid = true;
        this.$message.warning("请上传问题照片");
        return;
      }

      const ai = this.supItems.length;
      const problem = {
        ticket_id: "",
        device_type: this.supType,
        problem_type: "补充问题",
        issue_description: this.supStd.trim(),
        cause_solution_process: this.supOpinion.trim(),
        problem_photo: this.serializeProblemPhotos(
          this.supUploadFiles.map((file) => ({
            name: file.name,
            url: this.photoUrl(file),
          }))
        ),
        problem_level: "h",
      };
      this.paramsData.args.process_data.problem_data = [
        ...this.supItems.map((item) => ({
          ticket_id: item.ticket_id || "",
          device_type: item.device_type || "",
          problem_type: item.problem_type || "补充问题",
          issue_description: item.issue_description || "",
          cause_solution_process: item.cause_solution_process || "",
          problem_photo: this.serializeProblemPhotos(item.problem_photo),
          problem_level: item.problem_level || "h",
        })),
        problem,
      ];
      this.paramsData.args.process_user = this.user;
      this.paramsData.context = {
        ...this.context,
        method_name: "update",
      };

      try {
        await getDataByNbrokerUrl(this.paramsData, this.problemServiceUrl);
        this.$set(
          this.eviFiles,
          "sup_" + ai,
          this.normalizeProblemPhotos(problem.problem_photo)
            .map((photo) => photo.url)
            .filter(Boolean)
        );
        this.$set(this.eviFiles, "sup_form", []);
        this.supItems.push(problem);
        this.supItems = this.supItems.slice();
        this.$nextTick(() => this.validateAndUpdateCheckResult());
        this.supStd = "";
        this.supOpinion = "";
        this.supUploadFiles = [];
        this.supUploadInvalid = false;
        this.closeSupModal();
      } catch (error) {
        this.$message.error("补充问题保存失败，请稍后重试");
      }
    },
    async updateSupProblems() {
      if (this.isReadOnly) return;
      this.paramsData.args.process_data.problem_data = this.supItems.map((item) => ({
        ticket_id: item.ticket_id || "",
        device_type: item.device_type || "",
        problem_type: item.problem_type || "补充问题",
        issue_description: item.issue_description || "",
        cause_solution_process: item.cause_solution_process || "",
        problem_photo: this.serializeProblemPhotos(item.problem_photo),
        problem_level: item.problem_level || "h",
      }));
      this.paramsData.args.process_user = this.user;
      this.paramsData.context = {
        ...this.context,
        method_name: "update",
      };
      await getDataByNbrokerUrl(this.paramsData, this.problemServiceUrl);
    },
    async delSup(ai) {
      if (this.isReadOnly) return;
      const remainingItems = this.supItems.filter((item, index) => index !== ai);
      const previousItems = this.supItems;
      this.supItems = remainingItems;
      try {
        await this.updateSupProblems();
        this.$delete(this.eviFiles, `sup_${ai}`);
        this.supItems.forEach((item, index) => {
          this.$set(
            this.eviFiles,
            `sup_${index}`,
            this.normalizeProblemPhotos(item.problem_photo)
              .map((photo) => photo.url)
              .filter(Boolean)
          );
        });
        this.$nextTick(() => this.validateAndUpdateCheckResult());
      } catch (error) {
        this.supItems = previousItems;
        this.$message.error("补充问题删除失败，请稍后重试");
      }
    },
  },
};
</script>
<style scoped>
.manager-check-page {
  --red: #ff4d4f;
  --red-bg: #fff1f0;
  --orange: #faad14;
  --orange-bg: #fffbe6;
  --gray: #8c8c8c;
  --gray-bg: #f5f5f5;
  --blue: #0958d9;
  --blue-bg: #e6f0ff;
  --green: #52c41a;
  --green-bg: #f6ffed;
  --ink: #1f2329;
  --ink2: #646a73;
  --line: #e5e7eb;
  --bg: #f2f4f7;
  --card: #ffffff;
  --radius: 10px;
  width: 100%;
  max-width: 1440px;
  min-height: 100vh;
  margin: 0 auto;
  padding: clamp(12px, 2vw, 24px) clamp(12px, 4vw, 4%);
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei",
    sans-serif;
  background: var(--bg);
  color: var(--ink);
  font-size: 14px;
  line-height: 1.6;
  box-sizing: border-box;
}
.manager-check-page *,
.manager-check-page *::before,
.manager-check-page *::after {
  box-sizing: border-box;
}
.manager-check-page button,
.manager-check-page input,
.manager-check-page textarea,
.manager-check-page select {
  font-family: inherit;
  line-height: inherit;
  font-size: inherit;
}
.manager-check-page button {
  appearance: none;
  -webkit-appearance: none;
  -webkit-tap-highlight-color: transparent;
}
.manager-check-page input,
.manager-check-page textarea,
.manager-check-page select {
  max-width: 100%;
}
.card {
  background: var(--card, #fff);
  border: 1px solid var(--line, #e5e7eb);
  border-radius: 10px;
  padding: 16px;
  margin-bottom: 14px;
}

/* ===== 工单头 ===== */
.wo-top {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
.wo-desc {
  font-size: 13px;
  color: var(--ink2);
  margin-top: 6px;
  line-height: 1.6;
  max-width: 640px;
}
.rings-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  margin-top: 12px;
  padding-top: 14px;
  border-top: 1px solid var(--line);
}
.ring-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 0 16px;
}
.ring-block + .ring-block {
  border-left: 1px solid var(--line);
}
.big-ring {
  width: 96px;
  height: 96px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  background: conic-gradient(var(--gray-bg) 0 100%);
}
.big-ring i {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  color: var(--ink);
}
.legend {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 6px 16px;
  margin-top: 8px;
  font-size: 13px;
  color: var(--ink2);
}
.legend b {
  color: var(--ink);
  font-weight: 700;
  margin-left: 3px;
}
.dot {
  display: inline-block;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  margin-right: 5px;
  vertical-align: middle;
}
.wo-title {
  font-size: 18px;
  font-weight: 700;
}
.wo-no {
  color: var(--ink2);
  font-size: 13px;
}
.progress-ring {
  text-align: center;
}
.ring-sub {
  font-size: 11px;
  color: var(--ink2);
  margin-top: 3px;
}
.ring {
  width: 96px;
  height: 96px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  background: conic-gradient(var(--blue) 0 0%, #e9edf3 0 100%);
}
.ring i {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-style: normal;
  font-weight: 700;
  color: var(--blue);
  font-size: 24px;
}

/* ===== 布局 ===== */
.layout {
  display: block;
}
.layout > :last-child {
  width: 100%;
}
.side {
  display: none;
}
.side h4 {
  font-size: 13px;
  color: var(--ink2);
  margin: 10px 0 6px;
}
.side .tree div {
  padding: 5px 8px;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
}
.side .tree div.on {
  background: var(--blue-bg);
  color: var(--blue);
  font-weight: 600;
}
.side .tree div:hover {
  background: var(--blue-bg);
  color: var(--blue);
}
.statbar {
  height: 8px;
  border-radius: 4px;
  background: #e9edf3;
  overflow: hidden;
  margin: 4px 0 10px;
}
.statbar i {
  display: block;
  height: 100%;
  background: var(--blue);
  transition: width 0.3s;
}

/* ===== 专业分组 / 设备块 ===== */
.cat-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  margin: 20px 0 10px;
  font-size: 16px;
  min-width: 0;
}
.cat-title .cnt {
  min-width: 0;
  font-size: 12px;
  color: var(--ink2);
  font-weight: 400;
  overflow-wrap: anywhere;
}
.dev {
  border: 1px solid var(--line);
  border-radius: 10px;
  margin-bottom: 12px;
  overflow: hidden;
  background: #fff;
}
.dev.done {
  border-color: var(--green);
}
.dev-head {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  background: var(--blue-bg);
  border-bottom: 1px solid var(--line);
  border-left: 3px solid var(--blue);
  flex-wrap: nowrap;
  min-width: 0;
}
.dev-name,
.dev-loc,
.dev-prog {
  min-width: 0;
  overflow-wrap: anywhere;
}
.dev-name {
  flex: 1 1 auto;
  min-width: 0;
  font-weight: 700;
  font-size: 15px;
  color: var(--blue);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dev-loc {
  flex: 0 0 auto;
  font-size: 12px;
  color: var(--ink2);
}
.dev-head .dev-prog {
  flex: 0 0 auto;
  margin-left: auto;
}
.dev-prog {
  margin-left: auto;
  font-size: 12px;
  color: var(--ink2);
  white-space: nowrap;
}
.dev-batch {
  display: inline-flex;
  border: 1px solid var(--line);
  border-radius: 8px;
  overflow: hidden;
}
.dev-batch button {
  border: none;
  background: #fff;
  padding: 6px 14px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  color: var(--ink2);
}
.dev-batch button:hover {
  background: var(--gray-bg);
}
.dev-batch .bp {
  color: var(--green);
  border-right: 1px solid var(--line);
  background: var(--green-bg);
}
.dev-batch .bf {
  color: var(--red);
  background: var(--red-bg);
}

/* ===== 结果确认控件 ===== */
.seg {
  display: inline-flex;
  border: 1px solid var(--line);
  border-radius: 8px;
  overflow: hidden;
}
.seg button {
  border: none;
  background: #fff;
  padding: 6px 14px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  color: var(--ink2);
}
.seg button.on-pass {
  background: var(--green);
  color: #fff;
}
.seg button.on-fail {
  background: var(--red);
  color: #fff;
}
.cam-btn {
  border: 1px solid var(--blue);
  color: var(--blue);
  background: #fff;
  border-radius: 8px;
  padding: 5px 10px;
  font-size: 12px;
  cursor: pointer;
  margin-left: 6px;
  white-space: nowrap;
}
.note-field {
  display: none;
  margin-top: 6px;
}
.note-field.show {
  display: block;
}
.note-field input {
  width: 100%;
  border: 1px solid var(--orange);
  border-radius: 6px;
  padding: 6px 8px;
  font-size: 13px;
}
.fail-row {
  display: none;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px dashed var(--line);
}
.fail-row.show {
  display: block;
}
.fail-line {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 6px;
}
.att-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #fff;
  border: 1px solid var(--line);
  border-radius: 6px;
  padding: 3px 8px;
  font-size: 12px;
  color: var(--ink);
  max-width: 240px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}
.att-chip b {
  cursor: pointer;
  color: var(--red);
  font-weight: 700;
  flex: 0 0 auto;
}

/* ===== 复查明细：卡片式（PC/手机共用，宽度自适应） ===== */
.rc-table-head {
  display: grid;
  grid-template-columns: minmax(0, 2.2fr) minmax(0, 3.4fr) minmax(0, 2.4fr);
  gap: 14px;
  padding: 8px 14px;
  background: var(--gray-bg);
  border-bottom: 1px solid var(--line);
  color: var(--ink2);
  font-size: 12px;
  font-weight: 600;
}
.rc-list {
  display: flex;
  flex-direction: column;
}
.row-card {
  border-bottom: 1px solid var(--line);
  padding: 12px 14px;
}
.row-card:last-child {
  border-bottom: none;
}
.rc-main {
  display: grid;
  grid-template-columns: minmax(0, 2.2fr) minmax(0, 3.4fr) minmax(0, 2.4fr);
  gap: 14px;
  align-items: center;
}
.rc-item,
.rc-std,
.rc-res {
  min-width: 0;
}
.rc-item {
  line-height: 1.4;
}
.rc-std {
  font-size: 13px;
  color: var(--ink2);
  line-height: 1.5;
  overflow-wrap: anywhere;
}
.rc-res {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
}

/* ===== 人工补充不通过项 ===== */
.sup-badge {
  display: inline-block;
  background: var(--orange-bg);
  color: var(--orange);
  border-radius: 4px;
  font-size: 11px;
  font-weight: 700;
  padding: 0 6px;
  margin-left: 4px;
}
tr.sup td {
  background: #fffdf5;
}
.m-card.sup {
  background: #fffdf5;
}
.row-card.sup {
  background: #fffdf5;
}
.sup-form {
  padding: 12px 14px;
  border: 1px dashed var(--orange);
  background: #fffdf5;
  border-radius: 8px;
  margin-bottom: 12px;
}
.sup-form .row {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
  flex-wrap: wrap;
}
.sup-form .row:last-child {
  margin-bottom: 0;
}
.sup-form input[type="text"] {
  flex: 1;
  min-width: 180px;
  border: 1px solid var(--line);
  border-radius: 6px;
  padding: 8px 10px;
  font-size: 13px;
}
.sup-form select {
  border: 1px solid var(--line);
  border-radius: 6px;
  padding: 8px 10px;
  font-size: 13px;
  background: #fff;
  max-width: 100%;
}
/* ===== 问题等级标签 ===== */
.rlv {
  display: inline-flex;
  align-items: center;
  align-self: center;
  padding: 0 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  height: 22px;
  white-space: nowrap;
  border: 1px solid transparent;
}
.rlv.h {
  background: var(--red-bg);
  color: var(--red);
  border-color: var(--red);
}
.rlv.m {
  background: var(--orange-bg);
  color: var(--orange);
  border-color: var(--orange);
}
.rlv.l {
  background: var(--green-bg);
  color: var(--green);
  border-color: var(--green);
}
.sup-form .ok-btn {
  background: var(--orange);
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 8px 24px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}
.sup-form .cancel-btn {
  background: #fff;
  border: 1px solid var(--line);
  border-radius: 8px;
  padding: 8px 22px;
  font-size: 14px;
  cursor: pointer;
}
.sup-entry-btn {
  width: 100%;
  border: 1px dashed var(--orange);
  color: var(--orange);
  background: #fffdf5;
  border-radius: 8px;
  padding: 12px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}
.sup-entry-btn:hover {
  background: #fff3e0;
}
.sup-modal {
  display: none;
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 100;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
.sup-modal.show {
  display: flex;
}
.sup-dialog {
  background: #fff;
  border-radius: 14px;
  width: 100%;
  max-width: 560px;
  max-height: 90vh;
  overflow: auto;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.22);
}
.sup-dialog-title {
  font-size: 16px;
  font-weight: 700;
  padding: 16px 18px;
  border-bottom: 1px solid var(--line);
}
.sup-dialog .sup-form {
  border: none;
  background: none;
  padding: 18px;
  margin-bottom: 0;
}
.combo {
  position: relative;
  flex: 1;
  min-width: 180px;
}
.combo-input {
  width: 100%;
  border: 1px solid var(--line);
  border-radius: 6px;
  padding: 8px 10px;
  font-size: 13px;
  box-sizing: border-box;
}
.combo-list {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  max-height: 240px;
  overflow: auto;
  background: #fff;
  border: 1px solid var(--line);
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  z-index: 5;
}
.combo-list .opt {
  padding: 8px 12px;
  font-size: 13px;
  cursor: pointer;
  border-bottom: 1px solid #f2f4f7;
}
.combo-list .opt:last-child {
  border-bottom: none;
}
.combo-list .opt:hover,
.combo-list .opt.hl {
  background: var(--blue-bg);
  color: var(--blue);
}
.combo-empty {
  padding: 10px 12px;
  font-size: 13px;
  color: var(--ink2);
}
.sup-upload-invalid .el-upload--picture-card {
  border-color: var(--red);
}
.form-thumbs {
  display: inline-flex;
  gap: 6px;
  flex-wrap: wrap;
  vertical-align: middle;
}
.form-thumbs img {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid var(--line);
  cursor: pointer;
}
.del-btn {
  border: none;
  background: none;
  color: var(--red);
  cursor: pointer;
  font-size: 12px;
  margin-left: 6px;
}

/* ===== 照片证据 ===== */
.thumbs {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  margin-top: 6px;
}
.thumbs img {
  width: 44px;
  height: 44px;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid var(--line);
  cursor: pointer;
}
.img-modal {
  display: none;
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.75);
  z-index: 99;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 12px;
  padding: 20px;
}
.img-modal.show {
  display: flex;
}
.img-modal img {
  max-width: 92vw;
  max-height: 74vh;
  border-radius: 8px;
}
.img-modal .bar {
  display: flex;
  gap: 10px;
}
.img-modal button {
  border: none;
  border-radius: 8px;
  padding: 8px 20px;
  font-size: 14px;
  cursor: pointer;
}
.img-modal .del {
  background: var(--red);
  color: #fff;
}
.img-modal .cls {
  background: #fff;
}

/* ===== 结论区 ===== */
.concl-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 14px;
}
.veto-list li {
  margin: 4px 0 4px 18px;
  font-size: 13px;
}
.radio-row {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 8px 0;
}
.radio-row label {
  font-weight: 400;
  border: 1px solid var(--line);
  border-radius: 8px;
  padding: 10px 12px;
  display: flex;
  gap: 8px;
  align-items: flex-start;
  cursor: pointer;
}
.radio-row label.sel-pass {
  border-color: var(--green);
  background: var(--green-bg);
}
.radio-row label.sel-pass input {
  accent-color: var(--green);
}
.radio-row label.sel-warn {
  border-color: var(--red);
  background: var(--red-bg);
}
.radio-row label.sel-warn input {
  accent-color: var(--red);
}
.sign {
  border: 1px dashed var(--line);
  border-radius: 8px;
  padding: 14px;
  text-align: center;
  color: var(--ink2);
}
.sign.signed {
  border: 1px solid var(--green);
  color: var(--green);
  background: var(--green-bg);
}

/* ===== 底部操作栏 ===== */
.actionbar {
  position: sticky;
  bottom: 0;
  background: #fff;
  border-top: 1px solid var(--line);
  padding: 12px 16px;
  display: flex;
  gap: 10px;
  align-items: center;
  z-index: 50;
  border-radius: 10px;
  flex-wrap: wrap;
}
.actionbar .hint {
  color: var(--red);
  font-size: 12px;
  margin-right: auto;
}
.btn {
  border: 1px solid var(--line);
  background: #fff;
  border-radius: 8px;
  padding: 9px 22px;
  font-size: 14px;
  cursor: pointer;
  font-weight: 600;
}
.btn.primary {
  background: var(--blue);
  color: #fff;
  border-color: var(--blue);
}
.btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* ============ 响应式：宽度≤768px 自动切换手机布局 ============ */
@media (max-width: 64em) {
  .layout {
    display: block;
  }
  .side {
    display: none;
  }
  .rc-main {
    gap: 10px;
  }
  .dev-loc {
    overflow-wrap: anywhere;
  }
}
@media (max-width: 47.9375em) {
  .manager-check-page {
    width: 100%;
    min-width: 0;
    padding: 16px 4%;
    overflow-x: hidden;
  }
  .card {
    padding: 14px 16px;
  }
  .wo-title {
    font-size: 18px;
    line-height: 1.45;
  }
  .wo-desc {
    overflow-wrap: anywhere;
  }
  .layout {
    display: block;
  }
  .layout > :last-child {
    width: 100%;
  }
  .side {
    display: none;
  }
  .concl-grid {
    grid-template-columns: 1fr;
  }
  .rings-row {
    gap: 0;
  }
  .ring-block {
    min-width: 0;
    padding: 0 8px;
  }
  .legend {
    gap: 4px 8px;
    font-size: 12px;
  }
  .cat-title {
    flex-wrap: wrap;
  }
  .dev-head {
    padding: 10px 12px;
    gap: 4px 8px;
  }
  .dev-name {
    flex: 1 1 auto;
    min-width: 0;
  }
  .dev-loc {
    flex: 0 0 auto;
  }
  .dev-head .dev-prog {
    flex: 0 0 auto;
    margin-left: auto;
  }
  .dev-batch {
    width: 100%;
    margin-top: 8px;
  }
  .dev-batch button {
    flex: 1;
    height: 48px;
    font-size: 15px;
    font-weight: 700;
  }
  .dev-batch .bp {
    background: var(--green-bg);
    color: var(--green);
    border-right: 1px solid var(--line);
  }
  .dev-batch .bf {
    background: var(--red-bg);
    color: var(--red);
  }
  .actionbar .btn {
    flex: 1;
    padding: 12px 0;
    font-size: 15px;
  }
  /* 复查明细卡片：手机端单列堆叠 */
  .rc-table-head {
    display: none;
  }
  .rc-main {
    grid-template-columns: 1fr;
    gap: 8px;
  }
  .row-card {
    padding: 12px;
  }
  .rc-res .seg {
    display: flex;
    width: 100%;
  }
  .rc-res .seg button {
    flex: 1;
    height: 36px;
    font-size: 13px;
  }
  .rc-res .seg .pass-btn.on-pass {
    background: var(--green);
    color: #fff;
  }
  .rc-res .seg .fail-btn.on-fail {
    background: var(--red);
    color: #fff;
  }
  .rc-list .fail-row .cam-btn {
    height: 36px;
    margin-left: 0;
    padding: 5px 14px;
    font-size: 13px;
  }
  .sup-dialog {
    max-height: calc(100vh - 20px);
  }
  .sup-dialog .sup-form {
    padding: 14px;
  }
  .sup-dialog .sup-form .row:first-child {
    display: block;
  }
  .sup-dialog .combo {
    width: 100%;
    min-width: 0;
  }
  .sup-dialog .sup-form .row:first-child > span {
    display: flex;
    margin-top: 8px;
    white-space: normal !important;
  }
  .att-chip {
    max-width: min(240px, 100%);
  }
}
@media (max-width: 23.4375em) {
  .manager-check-page {
    padding: 12px;
  }
  .card {
    padding: 10px 12px;
  }
  .rings-row {
    grid-template-columns: 1fr 1fr;
  }
  .ring-block {
    padding: 0 4px;
  }
  .ring,
  .big-ring {
    width: 84px;
    height: 84px;
  }
  .ring i,
  .big-ring i {
    width: 64px;
    height: 64px;
  }
  .ring i {
    font-size: 21px;
  }
  .big-ring i {
    font-size: 24px;
  }
}
.dev-batch button:disabled,
.seg button:disabled,
.cam-btn:disabled,
.sup-entry-btn:disabled,
.del-btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
input:disabled,
input:read-only,
textarea:disabled,
textarea:read-only {
  background-color: #f5f7fa;
  cursor: not-allowed;
  color: #606266;
}
.risk-upload-readonly .el-upload {
  display: none !important;
}
.risk-upload-readonly .el-icon-close {
  display: none !important;
}
</style>
